import { render, staticRenderFns } from "./ObiFilter.vue?vue&type=template&id=056b49b0&scoped=true&"
import script from "./ObiFilter.vue?vue&type=script&lang=js&"
export * from "./ObiFilter.vue?vue&type=script&lang=js&"
import style0 from "./ObiFilter.vue?vue&type=style&index=0&id=056b49b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b49b0",
  null
  
)

export default component.exports